import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { QuoteFormValues } from 'modules/quote/types';
import { QuoteAftermarketProductType, QuoteFeeType } from '@trnsact/trnsact-shared-types';

import { InvoiceFormValues } from '../model';
import { newChargeRow } from '../../equipment';

// This fn it is just a temporary mapper from Invoice to Quote
// When we will switch from Invoice to Quote it should be removed
export function mapInvoiceFormValuesToQuote(formValues: InvoiceFormValues): QuoteFormValues {
  const equipmentId = uuidv4();

  return {
    term: null,
    interestRate: null,
    paymentAmount: null,
    downPayment: formValues.downPayment.flat,
    contractStartDate: moment().toISOString(),
    firstPaymentDueDate: moment().toISOString(),
    attributes: [],
    cashBackAmounts: [],
    fees: [
      {
        equipmentId: null,
        type: QuoteFeeType.StateTax,
        description: 'Invoice sales tax',
        amount: formValues.salesTaxOnInvoice,
        price: { ...newChargeRow, retailPrice: formValues.equipmentCost ?? 0 },
      },
      {
        equipmentId: null,
        type: QuoteFeeType.Other,
        amount: formValues.freightLaborInstallation,
        description: 'Other Charges (Installation, shipping etc.)',
        price: { ...newChargeRow, retailPrice: formValues.equipmentCost ?? 0 },
      },
    ],
    rebates: [
      {
        equipmentId: null,
        description: 'Rebate',
        amount: formValues.manufacturerRebateAmount,
      },
    ],
    aftermarketProducts: [
      {
        equipmentId: null,
        type: QuoteAftermarketProductType.Other,
        description: 'Warranty and Insurance Charges',
        cost: formValues.invoiceWarrantyAndInsuranceCharges,
      },
    ],
    equipment: [
      {
        vin: '',
        equipmentId,
        attributes: [],
        externalId: '',
        stockNumber: '',
        cost: formValues.equipmentCost,
        price: { ...newChargeRow, retailPrice: formValues.equipmentCost ?? 0 },
      },
    ],
    equipmentTradeIns: [
      {
        vin: '',
        equipmentId,
        externalId: '',
        stockNumber: '',
        tradeInDetails: {
          tradeValue: formValues.tradeAllowanceGrossTradeIn,
          tradeAmountOwed: formValues.tradeOwedBalanceAmount,
        },
      },
    ],
  };
}
